import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const YouTubeServices: React.FC = () => <PlatformServicePage platform="youtube" />;
export default YouTubeServices;
